import { render, staticRenderFns } from "./AutomaticReportForm.vue?vue&type=template&id=24421cb3&scoped=true&"
import script from "./AutomaticReportForm.vue?vue&type=script&lang=ts&"
export * from "./AutomaticReportForm.vue?vue&type=script&lang=ts&"
import style0 from "./AutomaticReportForm.vue?vue&type=style&index=0&id=24421cb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24421cb3",
  null
  
)

export default component.exports